import Color from '@styles/Color';
import React, { useLayoutEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';

const CURSOR_OFFSET = 14;
const EDGE_PADDING = 8;

const AlbumDescriptionWrap = styled.div`
  font-family: var(--defaultFontFamily);
  position: fixed;
  padding: 12px;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  color: ${Color.GRAY_1};
  width: max-content;
  max-width: min(200px, calc(100vw - ${EDGE_PADDING * 2}px));
  pointer-events: none;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  z-index: 9999;
  font-size: 13px;

  p {
    line-height: 1.4;
    font-size: 13px;
  }
`;

function FollowedDescription({ data, mouseOn, targetRef }) {
  const tooltipRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = tooltipRef.current;
    if (!el || !data || !mouseOn) return;

    const rect = el.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    let left = (targetRef.clientX ?? 0) + CURSOR_OFFSET;
    let top = (targetRef.clientY ?? 0) + CURSOR_OFFSET;

    // 오른쪽 경계 초과 시 왼쪽으로 이동
    if (left + rect.width > vw - EDGE_PADDING) {
      left = Math.max(EDGE_PADDING, vw - rect.width - EDGE_PADDING);
    }

    // 아래쪽 경계 초과 시 커서 위로 이동
    if (top + rect.height > vh - EDGE_PADDING) {
      top = Math.max(EDGE_PADDING, (targetRef.clientY ?? 0) - rect.height - CURSOR_OFFSET);
    }

    el.style.left = `${left}px`;
    el.style.top = `${top}px`;
  });

  // clientX가 null이면 아직 mousemove가 발생하지 않은 상태 (onMouseEnter 직후 등)
  // 이 경우 좌표를 알 수 없으므로 렌더링하지 않음
  if (!data || !mouseOn || targetRef.clientX == null) return null;

  return ReactDOM.createPortal(
    <AlbumDescriptionWrap
      ref={tooltipRef}
      style={{
        top: `${(targetRef.clientY ?? 0) + CURSOR_OFFSET}px`,
        left: `${(targetRef.clientX ?? 0) + CURSOR_OFFSET}px`,
      }}
    >
      <strong>{data.title}</strong>

      {data.description && (
        <>
          <hr
            style={{
              width: '100%',
              borderBottom: `1px solid ${Color.GRAY_6}`,
            }}
          />
          <p>{data.description}</p>
          {data.contents && <p>{data.contents}</p>}
        </>
      )}
    </AlbumDescriptionWrap>,
    document.body,
  );
}

export default React.memo(FollowedDescription);
